/**
 * Created by mukund on 5/4/16.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('lmsPlaybackAnalytics', {
                parent: 'site',
                url: '/lms/playback-analytics/:collectionId/:origin/:authToken',
                data: {
                    roles: [],
                    pageTitle: 'playback-analytics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/administration/playback_analytics/templates/playback-analytics.html',
                        controller: 'PlaybackAnalyticsController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('playback-analytics');
                        return $translate.refresh();
                    }]
                }
            });
    });
